import type { BillWithPayments } from '@/types'

import { EmptySeparator, InputLine, Label, QR } from './components'

function verifactu(bill: BillWithPayments) {
  if (!bill.metadata?.verifactu?.url) {
    return []
  }
  return [
    new EmptySeparator(),
    new QR(bill.metadata.verifactu.url),
    new Label('VERI*FACTU', {
      align: 'center',
      style: 'bold 12px',
      lineHeight: 20
    })
  ]
}

function mexico(bill: BillWithPayments) {
  if (!bill.metadata?.facturapi?.url) {
    return []
  }
  return [
    new EmptySeparator(),
    new Label('Certificación Digital del SAT', {
      align: 'center',
      style: 'bold 14px',
      lineHeight: 24
    }),
    new EmptySeparator({ lineHeight: 20 }),
    new QR(bill.metadata.facturapi.url)
  ]
}

function tbai(bill: BillWithPayments) {
  if (!bill.metadata?.tbai) {
    return []
  }
  return [
    new EmptySeparator(),
    new Label(bill.metadata.tbai.code, {
      align: 'center',
      style: 'bold 14px',
      lineHeight: 2
    }),
    new EmptySeparator({ lineHeight: 20 }),
    new QR(bill.metadata.tbai.url)
  ]
}

function kassensichv(bill: BillWithPayments) {
  if (!bill.metadata?.kassensichv?.qr_data) {
    return []
  }
  return [
    new Label('KassensichV', {
      align: 'center',
      style: 'bold 14px',
      lineHeight: 20
    }),
    new EmptySeparator({ lineHeight: 12 }),
    new QR(bill.metadata.kassensichv.qr_data, { height: 160 })
  ]
}

function input(label: string, lines = 1) {
  return [
    new Label(label, {
      style: 'bold 14px',
      lineHeight: 14
    }),
    new EmptySeparator(),
    ...Array(lines)
      .fill(0)
      .map(() => new InputLine({ size: 16 }))
  ]
}

function germany(enabled: boolean) {
  if (!enabled) return []
  return [
    new EmptySeparator(),
    ...input('Wer war dabei? (Bewirtete Personen)', 2),
    ...input("Was gab's zu feiern? (Anlass d. Bewirtung)", 2),
    ...input('Aufwendungen inkl. Trinkgeld', 1),
    ...input('bei Bewirtung in Restaurant', 1),
    ...input('in anderen Fällen', 1),
    ...input('Unterschrift des Gastes', 1)
  ]
}

export default function taxation(
  bill: BillWithPayments,
  options: any
): { header: any[]; footer: any[] } {
  return {
    header: [...verifactu(bill)],
    footer: [...mexico(bill), ...tbai(bill), ...kassensichv(bill), ...germany(options.hospitality)]
  }
}
